module.exports = __webpack_public_path__ + "vue/img/logo5.a3cb0a64.png";